module.exports = __webpack_public_path__ + "static/media/14feb.8013b22c.jpg";